var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-card"},[_c('div',{staticClass:"card-title"},[_vm._t("title")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }